import { render, staticRenderFns } from "./listaConsultas.vue?vue&type=template&id=9a16d7fc&scoped=true"
import script from "./listaConsultas.vue?vue&type=script&lang=js"
export * from "./listaConsultas.vue?vue&type=script&lang=js"
import style0 from "./listaConsultas.vue?vue&type=style&index=0&id=9a16d7fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a16d7fc",
  null
  
)

export default component.exports